import { Component } from '@angular/core';

@Component({
  selector: 'stars-anatomy-overview',
  templateUrl: './anatomy-overview.html',
  styleUrls: ['./anatomy-overview.scss']
})
export class AnatomyOverviewComponent {}
